import { Controller } from "@hotwired/stimulus"

// Where the page was meant to open. A redirect to "#post_503" loses its
// fragment under Turbo (fetch drops it), so the server keeps the id in the
// flash (LandsBeside) and this scrolls to it once the page is drawn, then puts
// the fragment back on the address so a reload or a shared link lands the
// same way. In a plain navigation the browser has already scrolled there,
// and this does no harm.
export default class extends Controller {
  static values = { at: String }

  connect() {
    const target = document.getElementById(this.atValue)
    if (!target) return

    requestAnimationFrame(() => target.scrollIntoView({ block: "start" }))
    if (window.location.hash !== `#${this.atValue}`) {
      history.replaceState(history.state, "", `${window.location.pathname}${window.location.search}#${this.atValue}`)
    }
  }
}
